module.exports = __webpack_public_path__ + "img/prometheus.b14e6dd1.svg";